import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UploadFileRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UploadFileResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const uploadFile = (request: UploadFileRequest, options?: CashRequestOptions) =>
  post<UploadFileRequest, UploadFileResponse>('/2.0/cash/upload-file', request, { ...options, rejectOnError: true })
